const root = process.env.REACT_APP_BACKEND_FINANCE_SERVICE_URL;

export const API = {
  baseUrl: root,
  nlpc: process.env.REACT_APP_BACKEND_EPS_URL,
  documentService: process.env.REACT_APP_BACKEND_HR_LEAVE_URL,
  controlService: process.env.REACT_APP_CONTROL_SERVICE,
  hrServices: process.env.REACT_APP_BACKEND_HR_URL,
  vendorBase: process.env.REACT_APP_BACKEND_VENDOR_URL,
  liveHRBase: process.env.REACT_APP_LIVE_HR_URL,
  APPROVE_PAYROLL: "/payroll/approvedeclinepayrollrun",
  DECLINE_PAAYROLL: "/payroll/approvedeclinepayrollrun",
  PAYROLL_OF_ALL_EMPLOYEES: "/payroll/payrollviewemployees",
  PAYROLL_VIEW_ALL_ITEMS: "/payroll/payrollviewallitem",
  REMOVE_FROM_PAYROLL: "/payroll/removestafffrompayroll",
  PREVIEW_BONUS: "/payroll/payrollviewallbonus",
  PREVIEW_ALL_BONUSES: "/payroll/payrollviewallbonus",
  PAYMENT_DETAILS: "/payrollpayment/paymentdetail",
  PAYMENT_SUMMARY: "/payrollpayment/paymentsummary",
  PAYMENT_LOG: "/payrollpayment/paymentLog",
  vendorPaymentDetails: "PayrollPayment/VendorPaymentDetail",
  COST_SERVICE_EXPENSES: "/costcenterexpenses/all",
  AUTHORIZE_PAYROLL: "/payroll/authorizedeclinepayrollrun",
  ADD_BUDGET: "/budgetimport/importyearlybudgetcommand",
  GET_BUDGET_SUMMARY: "/budgetimport/getbudgetsummaries",
  GET_BUDGET_DETAILS: "/budgetimport/getbudgetsummarydetailsquery",
  GET_BUDGET_DETAILS_BY_ID: "/BudgetImport",
  APPROVE_AND_DECLINE_BUDGET_DETAILS: "/budgetimport/ApproveDeclineBudgetItem",
  GET_LEDGER: "/accountledger/getallaccounts",
  GET_DEPARTMENT: "/Department/AllDepartment",
  LINK_BUDGET_TO_PAYMENT: "/payrollpayment/budget",
  LEDGER_ACCOUNTS: "/accountledger/getallaccounts",
  LINK_LEDGER_TO_PAYMENT: "/payrollpayment/ledger",
  PAYMENT_TYPE: "/paymenttype/all",
  GET_ACCOUNTS: "/accountledger/getallaccounts",
  GET_COMPANY_FUNDS: "/CompanyFund/CashbookQuery",
  APPROVE_PAYMENT_REQ: "/payrollpayment/approve",
  Decline_PAYMENT_REQ: "/payrollpayment/decline",
  UPLOAD_COOPERATIVE_DEDUCTIONS:
    "/cooperativemanagement/uploadcooperativeadvisecostcommand",
  DOWNLOAD_PAYMENT_SCHEDULE: "/payrollpayment/generateschedule",
  APPROVE_DECLINE_COOPERATIVE:
    "/cooperativemanagement/approveordeclinecooperativecomponentcommand",
  AUTHORIZE_COOPERATIVE:
    "/cooperativemanagement/authorizecooperativecomponentcommand",
  AUTHORIZE_NON_STATUTORY_ADVICE:
    "/NonStatutoryAdvise/AuthorizeNonStatutoryRequestCommand",
  ALL_COOPERATIIVE_MGT: "/cooperativemanagement/reviewcooperativerequestquery?",
  ALL_NON_STATUTORY_MGT: "/NonStatutoryAdvise/GetAllNonStatutoryAdviceQuery",
  APPROVE_DECLINE_NON_STATUTORY_ADVICE:
    "/NonStatutoryAdvise/ApproveDeclineNonStatutoryAdviseCommand",
  UPLOAD_NON_STATUTORY_DEDUCTIONS:
    "/NonStatutoryAdvise/uploadNonStatutoryAdvise",
  APPROVE_BUDGET: "/budgetimport/approveordeclinebudgetcommand",
  REMOVE_DEDUCTIONS: "/payroll/removenonstatutorydeduction",
  BOOKING_SERVICE_SETUP: "BookingServiceSetup/all",
  CARD_SETUP: "/CardSetup/all",
  CREATE_CARD_SETUP: "/CardSetup",
  CREATE_CARD_SETUP_UPDATE: "/CardSetup/update",
  SINGLE_SERVICE: "BookingServiceSetup",
  SETUP_BOOK_SERVICE: "BookingServiceSetup",
  FACILITY_SETUP: "BookingFacilitySetup",
  GET_BOOKING_SERVICES: "BookingService/all",
  GET_BOOKINGS: "BookingService/all",
  GET_BOOKING_SERVICE_DETAILS: "BookingServiceSetup",
  UPDATE_BOOK_SERVICE: "BookingServiceSetup/update",
  DELETE_BOOK_SERVICE: "BookingServiceSetup/delete",
  DECLINE_ACCOUNT_SETUP: "/CardSetup/decline",
  APPROVE_ACCOUNT_SETUP: "/CardSetup/approve",
  DELETE_BOOKING_FACILITY: "BookingFacilitySetup/delete",
  ADD_COMPONENT: "BookingFacilityComponentSetup",
  GET_COMPONENTS: "BookingFacilityComponentSetup/all",
  APPROVE_BOOKINGS: "BookingService/approve",
  DECLINE_BOOKINGS: "BookingService/decline",
  CREATE_BOOKING_SERVICES: "BookingServiceSetup",
  GET_BOOKING_FACILITY: "BookingFacilitySetup/all",
  HR: {
    CREATE_RATING_SCALE: "Ratings/create",
    GET_RATING_SCALE: "Ratings/all",
    GET_SINGLE_RATING_SCALE: "Ratings/id?Id=",
    Edit_RATING_SCALE: "Ratings/update",
    DELETE_RATING_SCALE: "Ratings/delete",
    APPROVE_DECLINE_RATING_SCALE: "Ratings/approve",
    GET_SCORE_RECOMMENDATION: "ScoreRecommendationSetup/all",
    CREATE_PERFORMANCE_LABEL: "PerformanceStatusLabel/create",
    GET_PERFORMANCElABEL: "PerformanceStatusLabel/all",
    GET_SINGLE_ERFORMANCE_LABEL: "PerformanceStatusLabel/id",
    APPROVE_DECLINE_STATUS_LABEL: "PerformanceStatusLabel/approve",
    DELETE_STATUS_LABEL: "PerformanceStatusLabel/delete",
    EDIT_STATUS_LABEL: "PerformanceStatusLabel/update",
    COUNSELLING_TYPE: "CounsellingSetup/all",
    Development_TYPE: "DevelopmentPlan/all",
    EXPECTED_IMPROVEMENT_PAN: "ExpectedImprovementPlan/all",
    CREATE_COUNSELLING_TYPE: "CounsellingSetup/create",
    CREATE_DEVELOPMENT_TYPE: "DevelopmentPlan/create",
    CREATE_IMPROVEMENT_PLAN: "ExpectedImprovementPlan/create",
    COUNSELLING_TYPE_APPROVE_DECLINE: "CounsellingSetup/approve",
    DEVELOPMENT_APPROVE_DECLINE: "DevelopmentPlan/approve",
    IMPROVEMENT_PERFORMANCE_APPROVE_DECLINE: "ExpectedImprovementPlan/approve",
    SINGLE_CONSELLING_TYPE: "CounsellingSetup/id",
    SINGLE_DEVELOPMENT_PLAN: "DevelopmentPlan/id",
    SINGLE_EXPECTED_IMPROVEMENT_PAN: "ExpectedImprovementPlan/id",
    EDIT_COUNSELLING_TYPE: "CounsellingSetup/update",
    EDIT_DEVELOPMENT_PLAN: "DEVELOPMENTPLAN/update",
    EDIT_IMPROVEMENT_PLAN: "ExpectedImprovementPlan/update",
    DELETE_COUNSELLING_TYPE: "CounsellingSetup/delete",
    DELETE_DEVELOPMENT_PLAN: "DevelopmentPlan/delete",
    DELETE_EXPECTED_IMPROVEMENT_PLAN: "ExpectedImprovementPlan/delete",
    CREATE_SCORE_RECOMMENDATION: "ScoreRecommendationSetup/create",
    DELETE_SCORE_BASED_RECOMMENDATION: "ScoreRecommendationSetup/delete",
    SING_SCORE_BASED_RECOMMENDATION: "ScoreRecommendationSetup/id",
    APPROVE_DECLINE_SCORE_BASED_RECOMMENDATION:
      "ScoreRecommendationSetup/approve",
    APPROVE_DECLINE_PIP: "PIP/approve",
    UPDATE_SCORE_BASED_RECOMMENDATION: "ScoreRecommendationSetup/update",
    GET_APPRAISAL_PERIOD: "AppraisalPeriod/all",
    GET_APPRAISAL_OBJECTIVES: "AppraisalObjective/all",
    CREATE_APPRAISAL_PERIOD: "AppraisalPeriod/create",
    APPROVE_DECLINE_APPRAISAL_PERIOD: "AppraisalPeriod/approve",
    DELETE_APPRAISAL_PERIOD: "AppraisalPeriod/delete",
    GET_SINGLE_APPRAISAL_PERIOD: "AppraisalPeriod/id",
    UPDATE_APPRAISAL_PERIOD: "AppraisalPeriod/update",
    CREATE_APPRAISAL_OBJECTIVE: "AppraisalObjective/create",
    GET_SINGLE_APPRAISAL_OBJECTIVE: "AppraisalObjective/id",
    DELETE_APPRAISAL_OBJECTIVE: "AppraisalObjective/delete",
    UPDATE_APPRAISAL_OBJECTIVE: "AppraisalObjective/update",
    APPROVE_DECLINE_OBJECTIVE: "AppraisalObjective/approve",
    GET_KRA_ALL: "RevisedKRA/all",
    CREATE_KRA: "RevisedKRA/create",
    VIEW_SINGLE_KEY_RESULT_AREA: "RevisedKRA/id",
    KeyResultArea_By_ID: "KeyResultArea",
    APPROVE_DECLINE_KRA: "RevisedKRA/approve",
    DELETE_KRA: "RevisedKRA/delete",
    UPDATE_KRA: "RevisedKRA/update",
    GET_PIP: "Appraisal/employee-review-details",
    CREATE_PIP: "PIP/create",
    GET_SINGLE_PIP: "PIP/id",
    GET_TRAINING_TYPE: "TrainingType",
    GET_TRAINING_REQUISITION: "EmployeeTrainingRequisition",
    HOD_APPRAISAL_REVIEW: "RevisedAppraisal/review-by-hod",
    GET_JOB_ROLE: "Designation/AllDesignation",
    MANAGEMENT_APPRAISAL_REVIEW: "Appraisal/submit-executive-review",
    GET_ONE_EMPLOYEEE_BY_ID: "Employee",
    CREATE_COMMITTEE: "Committee",
    DELETE_COMMITTEE: "Committee/delete",
    APPROVE_DECLINE_COMMITTEE: "Committee",
    UPDATE_COMMITTEE: "Committee/update",
    GET_SINGLE_MAIN_PIP: "PIP/id",
    GET_DESIGNATION_BY_ID: "Designation",
    GET_HOD_REVIEWS: "Appraisal/pending-hod-reviews",
    GET_EXCECUTIVE_REVIEWS: "Appraisal/pending-executive-reviews",
    EXCECUTIVE_APPRAISAL: "RevisedAppraisal/executive-review",
    HR_APPRASIAL_REVIEW: "Appraisal/executive-review/kra",
    GET_ALL_JOB_TITLE: "RecruitmentSetUp/AllJobTitle",
    MGT_COMMENTS: "RevisedAppraisal/executive-review",
    GET_RETENTION_METRICS: "FloatManagement/retention-metrics",
  },
  EMPLOYEE: {
    GET_SELF_REVIEW: "Appraisal/self-review",
    GET_SUMMARY: "Appraisal/assessment-summaries",
    GET_MAIN_SELF_REVIEW: "Appraisal/assessment",
    SUBMIT_SELF_REVIEW: "Appraisal/self-review/summary",
    LINE_MANAGER_REVIEW: "Appraisal/line-manager-review/kras",
    SAVE_LINE_MANAGER_REVIEW: "Appraisal/line-manager-review/kra",
    GET_EMPLOYEE_BY_ID: "Employee",
    REVIEW360_KRA: "RevisedAppraisal/360KraFeedbacK",
    ACKNOWLEDGE_APPRAISAL: "RevisedAppraisal/acknowledge",
    CROSS_REVIEW: "Appraisal/pending-cross-reviews",
    PEER_REVIEW: "Appraisal/pending-peer-reviews",
    UPWARD_REVIEW: "Appraisal/pending-upward-reviews",
    GET_EMPLOYEE_REVIE_DETAILS: "RevisedAppraisal",
    SUBMIT_CROSS_REVIEW: "Appraisal/cross-review",
    SUBMIT_PEER_REVIEW: "Appraisal/peer-review",
    SUBMIT_UPWARD_REVIEW: "Appraisal/upward-reviews",
    GET_PENDING_APPRAISALS: "Appraisal/pending-line-manager-reviews",
    EMPLOYEE_PIP_UPDATE: "PIP/update",
    GET_ALL_PIP_EMPLOYEE: "PIP/all",
    GET_PIP_BY_ID: "PIP/id?Id=",
    GET_ALL_PIP: "PIP/all",
    CALCULATE_ACTUAL_SCORE: "Appraisal/calculate-total-appraisal-score",
    CALCULATE_MAIN_SCORE: "Appraisal/calculate-kra-score",
    SAVE_SELF_KRA: "Appraisal/self-review/kra",
    SAVE_PEER_REVIEW: "Appraisal/peer-review/kra",
    SAVE_UPWARD_REVIEW: "Appraisal/upward-review/kra",
    SAVE_CROSS_REVIEW: "Appraisal/cross-review/kra",
    PEER_REVIEW_SUMMARY: "Appraisal/peer-review/summary",
    UPWARD_REVIEW_SUMMARY: "Appraisal/upward-review/summary",
    CROSS_REVIEW_SUMMARY: "Appraisal/cross-review/summary",
    GENERATE_REPORT: "Appraisal/report/",
    EMPLOYEE_FLOAT_DASHBOARD: "/FloatManagement/dashboard",
    CREATE_FLOAT_REQUEST: "FloatManagement/create",
    GET_ALL_FLOAT_REQUESTS: "FloatManagement/all",
    GET_FLOAT_BY_ID: "FloatManagement/id",
    UPDATE_FLOAT_REQUEST:"FloatManagement/update"
  },
  LINE_MANAGER_REVIEW: "Appraisal/line-manager-review",
  LINE_MANAGER_REVIEW_SUMMARY: "Appraisal/line-manager-review/summary",
  CONTROL: "ggg",
  FINANCE: {
    CREATE_SURVEY: "FloatRetirementSurveySetup",
    SUBMIT_EMPLOYEE_SURVEY: "FloatRetirement/submit",
    GET_RETIREMENT: "floatretirement/all",
    GET_RETIREMENT_BY_ID: "floatretirement",
    // GET_RETIREMENT_BY_ID: "FloatRetirement/id",
    APPROVE_FLOAT_RETIREMENT: "floatretirement/approve",
    REJECT_FLOAT_RETIREMENT: "floatretirement/reject",
    PREVIEW_SURVEY:"floatretirementsurveysetup/preview"
  
  },
};
